var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('patient-layout',[_c('patient-appointment-booking-slots-within-hour')],1)}
var staticRenderFns = []

export { render, staticRenderFns }